export default function ({ $axios, store }) {
  // Evita disparar dois redirecionamentos quando varias chamadas falham juntas
  // (a tela do aluno faz several requisicoes em paralelo ao abrir).
  let redirecionando = false

  $axios.onError((error) => {
    const status = error.response && error.response.status

    // 401 = a API recusou o token. Acontece com sessao expirada e tambem com os
    // tokens emitidos antes da migracao, que foram assinados com a chave RSA
    // antiga e nao validam mais. Antes disso o erro subia cru e o aluno via uma
    // tela de erro em vez de ser mandado para o login.
    //
    // O educacional nao tem login proprio: quem autentica e a loja. Por isso o
    // destino aqui e o MESMO que o middleware authentication.js ja usa quando
    // nao existe token nenhum, para nao criar um segundo caminho de logout.
    if (status === 401) {
      if (redirecionando) return
      redirecionando = true
      store.dispatch('credential/clearToken')
      window.location.replace(process.env.STORE_URL || 'https://loja.mege.com.br')
      return
    }

    if (status === 500) {
      // redirect('https://loja.mege.com.br')
    }
  })

  $axios.interceptors.response.use((response) => {
    if (response.status === 200) {
      if (
        response.request.responseURL &&
        response.request.responseURL.includes('login')
      ) {
        store.dispatch('setUser', response)
      }
    }
    return response
  })
}
